import PropTypes from 'prop-types';
import {
  ItemContainer,
  ItemDescription,
  ItemDetails,
  ItemDetailsPriceAligned,
  ItemImage,
  ItemMediaRow,
  ItemName,
  ItemWrapper,
} from './ProductItem.style';
import {
  InvoiceDiscountPriceStack,
  InvoiceDiscountPriceBeforeStruck,
  InvoiceDiscountPriceAfter,
} from '../../../../OrderInvoice.style';

const Item = ({
  key,
  mainImageUrl,
  serviceName,
  productShapeName,
  price,
  quantity,
  totalPrice,
  lineDiscount,
}) => {
  const unitPrice = Number(price) || 0;
  const qty = Number(quantity) || 1;
  const unitBeforeDiscount = lineDiscount ? lineDiscount.priceBefore : unitPrice;
  const unitAfterDiscount = lineDiscount ? lineDiscount.priceAfter : null;

  return (
    <ItemContainer key={key}>
      <ItemWrapper>
        <ItemMediaRow>
          {mainImageUrl && <ItemImage src={mainImageUrl} alt="item-image" />}
          <ItemDetails>
            <ItemName>{serviceName}</ItemName>
            {productShapeName && <ItemDescription>{productShapeName}</ItemDescription>}
          </ItemDetails>
        </ItemMediaRow>
        {lineDiscount ? (
          <ItemDetailsPriceAligned>
            <InvoiceDiscountPriceStack>
              <InvoiceDiscountPriceBeforeStruck>
                {unitBeforeDiscount.toFixed(2)}
              </InvoiceDiscountPriceBeforeStruck>
              <InvoiceDiscountPriceAfter>
                {(unitAfterDiscount != null ? unitAfterDiscount : unitPrice).toFixed(2)}
              </InvoiceDiscountPriceAfter>
            </InvoiceDiscountPriceStack>
          </ItemDetailsPriceAligned>
        ) : (
          <ItemDetails>
            <ItemName>{unitPrice.toFixed(2)}</ItemName>
          </ItemDetails>
        )}
        <ItemDetails>
          <ItemName>{`${quantity} Items`}</ItemName>
        </ItemDetails>
        {lineDiscount ? (
          <ItemDetailsPriceAligned>
            <InvoiceDiscountPriceStack>
              <InvoiceDiscountPriceBeforeStruck>
                {(unitBeforeDiscount * qty).toFixed(2)}
              </InvoiceDiscountPriceBeforeStruck>
              <InvoiceDiscountPriceAfter>
                {(unitAfterDiscount != null ? unitAfterDiscount * qty : unitPrice * qty).toFixed(2)}
              </InvoiceDiscountPriceAfter>
            </InvoiceDiscountPriceStack>
          </ItemDetailsPriceAligned>
        ) : (
          <ItemDetails>
            <ItemName>
              {typeof totalPrice === 'string' ? totalPrice : (unitPrice * qty).toFixed(2)}
            </ItemName>
          </ItemDetails>
        )}
      </ItemWrapper>
    </ItemContainer>
  );
};

Item.propTypes = {
  key: PropTypes.string,
  mainImageUrl: PropTypes.string,
  serviceName: PropTypes.string,
  productShapeName: PropTypes.string,
  price: PropTypes.number,
  quantity: PropTypes.number,
  totalPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  lineDiscount: PropTypes.shape({
    priceBefore: PropTypes.number,
    priceAfter: PropTypes.number,
  }),
};

Item.defaultProps = {
  lineDiscount: null,
};

export default Item;
